import { useEffect, useState } from 'react';
import { FacetState, FacetValue, Facet as FacetType } from '@coveo/headless';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { Checkbox, CheckboxGroup } from '@lmig/lmds-react-checkbox';
import { Link } from '@lmig/lmds-react-link';

export interface IFacetProps {
  title: string;
  facetType: React.MutableRefObject<FacetType>;
  defaultValue?: string;
}

export default function Facet({ title, facetType, defaultValue }: IFacetProps) {
  const [hasSelected, setHasSelected] = useState<boolean>(false);
  const [facetTypeState, setFacetTypeState] = useState<FacetState & { inputValue: string }>({
    ...facetType.current.state,
    inputValue: '',
  });

  useEffect(() => {
    if (defaultValue && !hasSelected && facetTypeState.values) {
      let defaultFacet = facetTypeState.values.find((x) => x.value.toLowerCase() == defaultValue.toLowerCase());
      if (defaultFacet && defaultFacet.state !== 'selected') {
        setHasSelected(true);
        toggleSelect(defaultFacet);
      }
    }
  }, [defaultValue, facetTypeState.values]);

  useEffect(() => {
    const unsub = facetType.current.subscribe(() => {
      setFacetTypeState((prevState) => {
        return {
          ...prevState,
          ...facetType.current.state,
        };
      });
    });
    return () => {
      unsub();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function toggleSelect(value: FacetValue) {
    facetType.current.toggleSelect(value);
  }

  function showMore() {
    facetType.current.showMoreValues();
  }

  function showLess() {
    facetType.current.showLessValues();
  }

  function getFacetValues() {
    return (
      <>
        {facetTypeState &&
          facetTypeState.values.map((value: FacetValue) => (
            <div key={value.value}>
              <CheckboxGroup onChange={function onChange() {}}>
                <Checkbox
                  checked={facetType.current.isValueSelected(value)}
                  labelVisual={`${value.value}`}
                  onChange={() => toggleSelect(value)}
                />
              </CheckboxGroup>
            </div>
          ))}
      </>
    );
  }
  function getFacetSearch() {
    return (
      <>
        {facetTypeState && (
          <Autocomplete
            inputValue={facetTypeState.inputValue}
            onInputChange={(_, newInputValue) => {
              setFacetTypeState({
                ...facetType.current.state,
                inputValue: newInputValue,
              });
              facetType.current.facetSearch.updateText(newInputValue);
              facetType.current.facetSearch.search();
            }}
            onChange={(_, chosenValue: any) => {
              if (chosenValue != null) {
                facetType.current.facetSearch.select(chosenValue);
              }
              setFacetTypeState({ ...facetType.current.state, inputValue: '' });
            }}
            options={facetTypeState.facetSearch.values}
            getOptionLabel={(option: any) => option.displayValue}
            blurOnSelect
            clearOnBlur
            className="search-facet-search"
            style={{ width: 'auto', maxWidth: '' }}
            renderInput={(params) => <TextField {...params} placeholder="Search" variant="outlined" size="small" />}
          />
        )}
      </>
    );
  }

  function getShowMore() {
    return (
      <Link
        className="search-facet-link caption"
        onClick={() => {
          showMore();
        }}
      >
        Show More
      </Link>
    );
  }

  function getShowLess() {
    return (
      <Link
        className="search-facet-link caption"
        onClick={() => {
          showLess();
        }}
      >
        Show Less
      </Link>
    );
  }
  return (
    <>
      {facetTypeState && facetTypeState.values.length !== 0 && (
        <div className="search-facet" style={{ minWidth: '190px' }}>
          <div className="search-facet-title">{title}</div>
          {getFacetValues()}
          {facetTypeState.canShowMoreValues && getFacetSearch()}
          {facetTypeState.canShowMoreValues && getShowMore()}
          {facetTypeState.canShowLessValues && getShowLess()}
        </div>
      )}
    </>
  );
}
